import {
  GET_DATE_FORMAT,
  UPDATE_DATE_FORMAT,
  UPDATE_START_WEEK_DAY,
} from "../../../modules/constants";
export function updateStartDayOfWeek(value) {
  return {
    type: UPDATE_START_WEEK_DAY,
    payload: value,
  };
}

export function getDateFormat(value) {
  return {
    type: GET_DATE_FORMAT,
    payload: value,
  };
}

export function updateDateFormat(value) {
  return {
    type: UPDATE_DATE_FORMAT,
    payload: value,
  };
}
